import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Button,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    useMediaQuery, Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";
import logo from "./img/logo.png";
import AccessibilityButton from "./Slepbutton";


const pages = [
    { label: "главная", path: "/" },
    { label: "Сведения об оо", path: "/documents" },
    { label: "ВсОШ", path: "/vsos" },
    { label: "Сведения об ООД", path: "/camp" },
    { label: "ЦДО", path: "/centraddedu" },
    { label: "о школе", path: "/about" },
    { label: "обучение", path: "/training" },
    { label: "питание", path: "/food" },
    { label: "контакты", path: "/contacts" },
];



export default function Navbar() {
    const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery("(max-width:900px)");

    const toggleDrawer = () => setOpen(!open);

    return (
        <Container >
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    backgroundColor: "hsla(73, 53%, 79%, 0.2)",
                    backdropFilter: "blur(6px)",
                }}
            >
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* --- Логотип --- */}
                    <NavLink to="/" style={{ textDecoration: "none" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <div className="logo-container">
                                <img className={'logo'} src={logo} alt="Logo" width="40" />
                            </div>
                            <Typography
                                variant="h6"
                                color="text.primary"
                                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
                            >
                            </Typography>
                        </Box>
                    </NavLink>

                    {/* --- Версия для слабовидящих (desktop) --- */}
                    {!isMobile && (
                        <Box
                            component="a"
                            href="#"
                            sx={{ display: "flex", alignItems: "center", mx: 2 }}
                        >
                            <AccessibilityButton/>
                        </Box>
                    )}

                    {/* --- Навигация / меню --- */}
                    {isMobile ? (
                        <>
                            <IconButton onClick={toggleDrawer} color="black">
                                <MenuIcon />
                            </IconButton>
                            <Drawer anchor="right" open={open} onClose={toggleDrawer}>
                                <Box
                                    sx={{ width: 250, p: 2 }}
                                    role="presentation"
                                    onClick={toggleDrawer}
                                >
                                    <List>
                                        <ListItem>
                                            {/*<img*/}
                                            {/*    src="https://lidrekon.ru/images/special.png"*/}
                                            {/*    alt="Версия для слабовидящих"*/}
                                            {/*    style={{ width: 50, marginBottom: 8 }}*/}
                                            {/*/>*/}
                                        </ListItem>
                                        {pages.map((page) => (
                                            <ListItem key={page.path} disablePadding>
                                                <ListItemButton
                                                    component={NavLink}
                                                    to={page.path}
                                                    sx={{
                                                        textTransform: "uppercase",
                                                        color: "text.primary",
                                                    }}
                                                >
                                                    <ListItemText primary={page.label} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Drawer>
                        </>
                    ) : (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.path}
                                    component={NavLink}
                                    to={page.path}
                                    sx={{
                                        textTransform: "uppercase",
                                        fontSize: "1rem",
                                        color: "text.primary",
                                        "&.active": { color: "primary.main", fontWeight: "bold" },
                                    }}
                                >
                                    <Typography variant={'subtitle2'}>{page.label}</Typography>
                                </Button>
                            ))}
                        </Box>
                    )}
                </Toolbar>
            </AppBar>
        </Container>
    );
}
